"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
const _ = __importStar(require("lodash"));
class Address {
    static getFromGoogleAddress(details) {
        if (details !== null &&
            typeof details === 'object' &&
            details.hasOwnProperty('address_components') &&
            details.address_components instanceof Array) {
            let address1 = '';
            let address2 = '';
            let city = '';
            let zipCode = '';
            let state = '';
            let country = '';
            let countryCode = '';
            details.address_components.forEach((address_component) => {
                const addressType = address_component.types[0];
                const addressValue = address_component['long_name'];
                if (addressType.toLowerCase() === 'street_number') {
                    address1 = addressValue;
                }
                else if (addressType.toLowerCase() === 'route') {
                    address2 = addressValue;
                }
                else if (addressType.toLowerCase() === 'locality') {
                    city = addressValue;
                }
                else if (addressType.toLowerCase() === 'administrative_area_level_1') {
                    state = addressValue;
                }
                else if (addressType.toLowerCase() === 'postal_code') {
                    zipCode = addressValue;
                }
                else if (addressType.toLowerCase() === 'country') {
                    country = addressValue;
                    countryCode = address_component['short_name'];
                }
            });
            return new Address({
                address1,
                address2,
                city,
                zipCode,
                state,
                country,
                countryCode,
                apartmentNumber: ''
            });
        }
        return null;
    }
    constructor(address) {
        this.address1 = '';
        this.address2 = '';
        this.city = '';
        this.zipCode = '';
        this.state = '';
        this.country = '';
        this.countryCode = '';
        this.apartmentNumber = '';
        this.toString = () => {
            const arr = [
                this.address1,
                this.address2,
                this.city,
                this.state,
                this.countryCode,
                this.zipCode
            ];
            return _.compact(arr).join(',\n');
        };
        if (address) {
            this.address1 = address.address1;
            this.address2 = address.address2;
            this.city = address.city;
            this.zipCode = address.zipCode;
            this.state = address.state;
            this.country = address.country;
            this.countryCode = address.countryCode;
            this.apartmentNumber = address.apartmentNumber;
        }
    }
}
exports.Address = Address;
//# sourceMappingURL=Address.js.map